import gql from 'graphql-tag';

export default gql`
    mutation UpdateLoadStatus($input: LoadStatusEdit) {
        updateLoadStatus(input: $input) {
            errors
        }
    }
`;
